import "core-js/modules/es.array.join";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { saveIgnorepayserverbygame } from "@/api/dataAll/dataAll";
export default {
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      dialogFormVisible: false,
      paramsData: {
        server_id: ""
      },
      rules: {
        server_id: [{
          required: true,
          message: "请选择服务器",
          trigger: "blur"
        }]
      }
    };
  },
  props: {
    serverList: {
      type: Array,
      default: []
    }
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.checked = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = {};
          params.server_ids = _this2.paramsData.server_id.join(",");
          saveIgnorepayserverbygame(_objectSpread(_objectSpread({}, params), {}, {
            game_id: _this2.rawData.game_id
          })).then(function (res) {
            if (res.status == 200) {
              _this2.$message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.$refs.ruleForm.resetFields();
    }
  }
};